import { useObserver } from "mobx-react";
import React from "react";
import locale from "@bonliva-crm/locale";
import { Switch, FormControlLabel } from "@material-ui/core";
import { CustomerContactPersonFragment } from "@graphql";
import { Subheading } from "@components";
import FilterSection from "./FilterSection/FilterSection";
import { CustomerProfileStore } from "./CustomerProfileStore";
import CustomerContactPersons from "../CustomerContactPersons/CustomerContactPersons";
import { DeleteContactPersonDialog } from "./DeleteContactPersonDialog/DeleteContactPersonDialog";

type Props = { store: CustomerProfileStore };

export const CustomerProfileContactPersons = ({ store }: Props) => {
  return useObserver(() => (
    <>
      <FilterSection<CustomerContactPersonFragment>
        title={locale["Contact persons"]}
        renderTitle={({ filter }) => (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <Subheading>{locale["Contact persons"]}</Subheading>

            <FormControlLabel
              control={
                <Switch
                  onChange={(_, v) => store.toggleShowAllContactPersons(v)}
                  value={store.showAllContactPersons}
                />
              }
              label={locale.ShowAll}
              style={{ marginLeft: 8 }}
            />

            <FormControlLabel
              control={
                <Switch
                  onChange={(_, v) => store.toggleShowDeletedContactPersons(v)}
                  value={store.showDeletedContactPersons}
                />
              }
              label={locale.ShowDeleted}
              style={{ marginLeft: 8 }}
            />

            <div style={{ marginLeft: "auto" }}>{filter}</div>
          </div>
        )}
        items={store.availableContactPersons}
        selectedItems={store.selectedContactPersons}
      >
        {(items, search) => (
          <CustomerContactPersons
            addNewTitle={locale.AddContactPerson(store.customerGroup)}
            canAdd
            canEdit
            data={items}
            fauxItems={store.fauxContactPersons}
            highlightImportant
            onAdd={() => store.openContactPersonEditor(null)}
            onDelete={(item) => store.openDeleteContactDialog(item._id, item.Name)}
            onEdit={(id) => store.openContactPersonEditor(id)}
            onSelect={store.handleContactPersonSelect}
            loading={false} // not implemented
            search={search}
            withCheckboxes
          />
        )}
      </FilterSection>

      <DeleteContactPersonDialog store={store} />
    </>
  ));
};
